import CheckListService from '../../../services/checklistdb/checklistdbService';
const api = new CheckListService()
const state = {
    alunos: [],
    alunos_loading: false,
    aluno_imagem_loading: false,
    pletivos: [],
    materiais: [],
    loading_id: null,
    settings: {}
}
const getters = {
    StateCheckLists: state => state.checklists,
    StateCheckListAlunos: state => state.alunos,
    /* Materiais */
    StateCheckListMateriais: state => state.materiais,
    StateCheckListPletivos: state => state.pletivos,
}
const mutations = {
    setCheckListSettings(state, value){ state.settings = value },
    // setCheckLists(state, value){ state.checklists = value },
    setCheckListAlunos(state, value){ state.alunos = value },
    setCheckListPletivos(state, value){ state.pletivos = value },
    setCheckListMateriais(state, value){ state.materiais = value },
    setCheckListLoadingID(state, value){ state.loading_id = value },
}
const actions = {
    /**  ------------------ SETTINGS ------------------- */
    /** Settings */
    async GetCheckListSettings({ commit }) {
        commit('setCheckListLoadingID', 'loading-settings')
        try{
            const response = await api.get(`settings/first_settings/`)
            const data = response.data
            if (data && data.id)
                commit('setCheckListSettings', data)
            else
                commit("setAlerts", [ {
                    tag: 'warn',
                    title:'Configuração',
                    message:`Nenhuma configuração foi carregada`
                    }
                ])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
    },
    /**  ------------------ COMPROVANTE ------------------- */
    /** Enviar comprovante por e-mail */
    async SendCheckListComprovante({ commit }, listaaluno_id) {
        commit('setCheckListLoadingID', 'send-email-comprovante')
        try{
            await api.post(`lista-aluno/${listaaluno_id}/enviar_comprovante/`)
            commit("setAlerts", [ {
                tag:'success',
                title:'Comprovante de Entrega',
                message:`Uma notificação de itens entregues e pendentes foi enviada por e-mail!`
                }
            ])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
    },
    /** Atualizar uma Configuracao */
    async UpdateCheckListSetting({ commit }, data) {
        commit('setCheckListLoadingID', `update-settings-${data.id}`)
        var updated = false
        try{
            await api.patch(`settings/${data.id}/`, data )
            updated = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return updated
    },
    /**  ------------------ FINANCEIRO ------------------- */
    /** Listas com itens pendentes para obtenção de saldo devido para o Financeiro */
    async GetCheckListFinanceiro({ commit }, params={}) {
        commit('setCheckListLoadingID', 'loading-financeiro')
        var listas = []
        try{
            const response = await api.get('lista-aluno/financeiro/',{ page_size: 1000, ...params })
            listas = response.data
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return listas
    },
    /**  ------------------ MATERIAL ------------------- */
    /** Materiais */
    async GetCheckListMateriais({ commit }, params={}) {
        commit('setCheckListLoadingID', 'loading-materiais')
        try{
            const response = await api.get('materiais/',{ page_size: 1000, ...params })
            commit('setCheckListMateriais', response.data.results)
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
    },
    /** Atualizar um Material */
    async UpdateCheckListMaterial({commit, dispatch}, data) {
        commit('setCheckListLoadingID', data.id)
        try{
            await api.patch(`materiais/${data.id}/`, data )
            let localstorage_codperlet = localStorage.getItem('codperlet_checklist')
            dispatch('GetCheckListMateriais', {codperlet: localstorage_codperlet})
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
    },
    /** Criar um Material */
    async CreateCheckListMaterial({commit, dispatch}, data) {
        commit('setCheckListLoadingID', 'create-material')
        try{
            await api.post(`materiais/`, data )
            let localstorage_codperlet = localStorage.getItem('codperlet_checklist')
            dispatch('GetCheckListMateriais', {codperlet: localstorage_codperlet})
            commit('setCheckListLoadingID', null)
            commit("setAlerts", [ {
                tag:'success',
                title:'Inclusão de Material',
                message:`Material ${data.descricao} criado com sucesso!`
                }
            ])
            return true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
            commit('setCheckListLoadingID', null)
            return false
        }
    },
    /** Remover um Material */
    async DeleteCheckListMaterial({ commit, dispatch}, data) {
        const confirma = confirm('Tem certeza que deseja remover o material '+data.descricao+'?')
        if (!confirma) return null
        commit('setCheckListLoadingID', `delete-${data.id}`)
        try{
            await api.delete(`materiais/${data.id}/` )
            let localstorage_codperlet = localStorage.getItem('codperlet_checklist')
            dispatch('GetCheckListMateriais', {codperlet: localstorage_codperlet})
            commit('setCheckListLoadingID', null)
            return true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
            commit('setCheckListLoadingID', null)
            return false
        }
    },
    /**  ------------------ LISTAS ------------------- */
    /** Listas */
    async GetCheckLists({ commit }, params={}) {
        commit('setCheckListLoadingID', 'get-checklists')
        var listas = []
        try{
            let response = await api.get('listas/',{...params, page_size:500})
            // commit('setCheckLists', response.data.results)
            listas = response.data.results
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return listas
    },
    /** Criar uma Lista */
    async CreateCheckList({ commit }, data) {
        commit('setCheckListLoadingID', 'create-lista')
        var created = false
        try{
            await api.post('listas/',data)
            created = true
            commit("setAlerts", [ {
                tag:'success',
                title:'Inclusão de nova Lista',
                message:`Lista ${data.titulo} criada com sucesso!`
                }
            ])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    /** Alterar uma Lista */
    async UpdateCheckList({ commit }, data) {
        commit('setCheckListLoadingID', `update-lista-${data.id}`)
        var updated = false
        try{
            await api.patch(`listas/${data.id}/`, data)
            updated = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return updated
    },
    /** Remover uma lista */
    async DeleteCheckList({ commit }, data) {
        commit('setCheckListLoadingID', `delete-lista-${data.id}`)
        var deleted = false
        try{
            await api.delete(`listas/${data.id}/`)
            commit("setAlerts", [ {
                tag:'success',
                    title:'Exclusão de Lista',
                    message:`A lista ${data.titulo} foi removida com sucesso!`
                }
            ])
            deleted = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return deleted
    },
    /**  ------------------ RM INTEGRADOR ------------------- */
    /** Pesquisa Taxas */
    async GetCheckListTaxaMateriais({ commit }, params={}) {
        commit('setCheckListLoadingID', 'get-taxa-materiais')
        var taxas = []
        try{
            let response = await api.get('api-rm/get_alu_taxa_materiais/',{...params, page_size:100})
            taxas = response.data
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return taxas
    },
    /** Pesquisa Alunos */
    async GetCheckListAlunos({ commit }, params={}) {
        commit('setCheckListLoadingID', 'get-alunos')
        try{
            let response = await api.get('api-rm/get_alu_db/',{...params, page_size:100})
            commit('setCheckListAlunos', response.data)
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
    },
    /** Carrega IMagem do Aluno */
    async GetCheckListAlunoImagem({ commit }, params={}) {
        var imagem = null
        commit('setCheckListLoadingID', `get-aluno-imagem-${params.codpessoa}`)
        try{
            const response = await api.get('api-rm/get_alu_image_db/',{...params, page_size:100})
            if (response.data.length > 0){
                imagem = response.data[0].IMAGEM
            }
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return imagem
    },
    /** Carrega Pletivos */
    // async GetCheckListPletivos({ commit }, params={}) {
    //     commit('setCheckListLoadingID', 'get-pletivos')
    //     try{
    //         let response = await api.get('api-rm/get_pletivos_db/',{...params, page_size:100})
    //         commit('setCheckListPletivos', response.data)
    //     }catch(error){
    //         commit("setAlerts", [ error.toast_message ])
    //     }
    //     commit('setCheckListLoadingID', null)
    // },
    /**  ------------------ LISTA-ALUNO ------------------- */
    /** Listar as listas do aluno */
    async GetCheckListAlunoListas({ commit }, params={}) {
        var listas =[]
        commit('setCheckListLoadingID', `get-aluno-listas-${params.ra}`)
        try{
            const response = await api.get('lista-aluno/',{...params})
            listas = response.data.results
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return listas
    },
    /** Alterar uma lista aluno*/
    async UpdateCheckListListaAluno({ commit }, data={}) {
        var updated = false
        commit('setCheckListLoadingID', `update-lista-aluno-${data.id}`)
        try{
            await api.patch(`lista-aluno/${data.id}/`, data)
            updated= true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return updated
    },
    /** Criar Lista Aluno */
    async CreateCheckListAlunoLista({ commit }, data) {
        var created = false
        commit('setCheckListLoadingID', 'add-aluno-lista')
        try{
            await api.post(`lista-aluno/`, data)
            created = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    /** Remover Lista Aluno */
    async DeleteCheckListAlunoLista({ commit }, data) {
        var deleted = false
        commit('setCheckListLoadingID', `delete-aluno-lista-${data.id}`)
        try{
            await api.delete(`lista-aluno/${data.id}/`)
            deleted = true
            commit("setAlerts", [ {
                tag:'success',
                    title:'Exclusão de Lista do Aluno',
                    message:`A lista ${data.lista_object.titulo} de ${data.lista_object.codperlet} do aluno ${data.ra}-${data.nome}`
                }
            ])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return deleted
    },
    /** Carregar uma lista pelo ID */
    async GetCheckListAlunoLista({ commit }, id) {
        var lista = {}
        commit('setCheckListLoadingID', 'get-aluno-lista')
        try{
            const response = await api.get(`lista-aluno/${id}/`)
            lista = response.data
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return lista
    },
    /** Receber um Material de uma Lista Aluno */
    async ReceberMaterialListaAluno({ commit }, data) {
        commit('setCheckListLoadingID', `recebendo-${data.id}`)
        var recebido = false
        try{
            await api.post(`itens-lista-aluno/${data.id}/receber_material/`, data )
            recebido = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return recebido
    },
    /**  ------------------ LISTA-MATERIAL ------------------- */
    /** Listar os itens da lista */
    async GetCheckListListaMateriais({ commit }, params={}) {
        var lista_materiais =[]
        commit('setCheckListLoadingID', 'get-lista-materiais')
        try{
            const response = await api.get('itens-lista/',{...params, page_size: 100})
            lista_materiais = response.data.results
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return lista_materiais
    },
    /** Vincular um item a uma lista */
    async CreateCheckListListaMaterial({ commit }, data={}) {
        var created = false
        commit('setCheckListLoadingID', 'create-lista-materiais')
        try{
            await api.post('itens-lista/', data)
            created= true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    /** Remover um item da lista */
    async DeleteCheckListListaMaterial({ commit }, data={}) {
        var deleted = false
        commit('setCheckListLoadingID', `delete-lista-materiais-${data.id}`)
        try{
            await api.delete(`itens-lista/${data.id}/`)
            deleted= true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return deleted
    },
    /** Alterar um item da lista (quantidade exigida)*/
    async UpdateCheckListListaMaterial({ commit }, data={}) {
        var updated = false
        commit('setCheckListLoadingID', `update-lista-materiais-${data.id}`)
        try{
            await api.patch(`itens-lista/${data.id}/`, data)
            updated= true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return updated
    },

    /** LUPI */
    async GetEntregaMaterialLupiLocal({ commit }) {
        // Lista de Locais para recebimento de material
        commit('setCheckListLoadingID', 'entrega-material-lupi-locais')
        var results = []
        try{
            const response = await api.get('entrega-material-locais/', {page_size: 100})
            results = response.data.results
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return results
    },
    
    async RegistrarEntregaMaterialLupi({ commit }, data) {
        // Registra entrega de material Lupi para o aluno
        var created = false
        commit('setCheckListLoadingID', 'registra-entrega-material-lupi')
        try{
            await api.post('entrega-material/', data)
            created = true
            commit('setAlerts', [{
                tag:'success',
                position: 'top-right',
                title:'Registro de Entrega',
                message: `(${data.quantidade_entregue}) [${data.descricao_item_lupi}] registrado com sucesso`}])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    async EntregarParcialMaterialLupi({ commit }, data) {
        // Registra entrega PARCIAL de material Lupi para o aluno
        var created = false
        commit('setCheckListLoadingID', 'entregar-parcial-material-lupi')
        try{
            await api.post(`entrega-material/${data.id}/entregar_parcial/`, data)
            created = true
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    async DevolverParcialMaterialLupi({ commit }, data) {
        // Registra devolucao PARCIAL de material Lupi para o aluno
        var created = false
        commit('setCheckListLoadingID', 'devolver-parcial-material-lupi')
        try{
            await api.post(`entrega-material/${data.objeto.id}/devolver_parcial/`, data)
            created = true
            commit('setAlerts', [{
                    tag:'success',
                    position: 'top-right',
                    title:'Devolução parcial de material',
                    message: `(${data.devolvendo}) [${data.objeto.descricao_item_lupi}] devolvido com sucesso`}])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return created
    },
    async GetEntregaMaterialLupi({ commit }, params={}) {
        // Lista de entregas do aluno
        var lista_materiais = []
        commit('setCheckListLoadingID', 'lista-material-lupi')
        try{
            const response = await api.get('entrega-material/', {...params, page_size: 100})
            lista_materiais = response.data.results
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return lista_materiais
    },
    async DeleteEntregaMaterialLupi({ commit }, data) {
        console.log('delete store', data)
        const confirma = confirm('Este processo removerá todos os registros de entregas do material '+data.descricao_item_lupi+' para o aluno '+data.ra+' '+data.nome+'! Deseja prosseguir?')
        if (!confirma) return null
        var deleted = false
        commit('setCheckListLoadingID', `delete-material-lupi-${data.id}`)
        try{
            await api.delete(`entrega-material/${data.id}/`)
            deleted = true
            commit("setAlerts", [
                {
                    tag:'success',
                    position: 'top-right',
                    title:'Cancelamento de Entrega',
                    message:`Entrega de item ${data.descricao_item_lupi} foi cancelada com sucesso!`
                }
            ])
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setCheckListLoadingID', null)
        return deleted
    },
}
export default {
    state,
    getters,
    actions,
    mutations
};